import { render, staticRenderFns } from "./_.vue?vue&type=template&id=5265e6de&lang=pug"
import script from "./_.vue?vue&type=script&lang=ts"
export * from "./_.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VBreadcrumbs: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VBreadcrumbs/VBreadcrumbs.js').default,VIcon: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VIcon/VIcon.js').default,VListItemAvatar: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VList/VListItemAvatar.js').default,VListItem: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VList/VListItem.js').default,VDivider: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VDivider/VDivider.js').default,VList: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VList/VList.js').default,VContainer: require('/home/runner/work/EC-Website/EC-Website/node_modules/vuetify/lib/components/VGrid/VContainer.js').default})
